// Jednotné formáty: datum 16. 10. 2026, částky 99 685,60 Kč
export const fmtDate = (v) => {
    if (!v) return "";
    const s = String(v);
    const m = s.match(/^(\d{4})-(\d{2})-(\d{2})/);
    if (!m) return s;
    return `${Number(m[3])}. ${Number(m[2])}. ${m[1]}`;
};
export const fmtDateTime = (v) => (v ? `${fmtDate(v)}${String(v).length > 10 ? ` ${String(v).slice(11, 16)}` : ""}` : "");
export const fmtKc = (n) => (Number(n) || 0).toLocaleString("cs-CZ", { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + " Kč";
export const fmtNum2 = (n) => (Number(n) || 0).toLocaleString("cs-CZ", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
export const fmtH = (n) => fmtNum2(n) + " h";
export const fmtKm = (n) => { const v = Number(n) || 0; return v.toLocaleString("cs-CZ", { maximumFractionDigits: Number.isInteger(v) ? 0 : 1 }) + " km"; };
